
<ng-template [ngIf]="contentControls.length > 0">
  <ng-container *ngFor="let ctrl of contentControls">
    
    <app-smart-label *ngIf="ctrl?.ctrlName === 'smartlabel'" [config]="ctrl.config"
      [data]="{entityInformation: pageService.diData }"></app-smart-label>
    <app-tabs *ngIf="ctrl?.ctrlName === 'tabs'" [config]="ctrl.config" [controls]="ctrl.controls"></app-tabs>
    <app-header *ngIf="ctrl?.ctrlName === 'header'" [config]="ctrl.config"></app-header>
    <app-carousel *ngIf="ctrl?.ctrlName === 'carousel'" [config]="ctrl.config" [data]="pageService.diData">
    </app-carousel>
    <app-list *ngIf="ctrl?.ctrlName === 'list'" [config]="ctrl.config" [controls]="ctrl.controls"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"></app-list>
    <app-list *ngIf="ctrl?.ctrlName === 'static-list'" [config]="ctrl.config" [controls]="ctrl.controls"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"></app-list>
    <app-jumbotron *ngIf="ctrl?.ctrlName === 'jumbotron'" [config]="ctrl.config" [data]="pageService.diData">
    </app-jumbotron>
    <app-button-segments *ngIf="ctrl?.ctrlName === 'button-segments'" [config]="ctrl.config"></app-button-segments>

    <app-rich-text *ngIf="ctrl?.ctrlName === 'rich-text'" [config]="ctrl.config" [data]="pageService.diData">
    </app-rich-text>
    <app-heading *ngIf="ctrl?.ctrlName === 'heading'" [config]="ctrl.config" [data]="
      {entityInformation: pageService.diData,
      customGetAPI: pageService.customGetAPIData}">
    </app-heading>
    

    <app-maps *ngIf="ctrl?.ctrlName === 'maps'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"></app-maps>

    <app-footer *ngIf="ctrl?.ctrlName === 'footer'" [config]="ctrl.config"></app-footer>

    <app-footer-links *ngIf="ctrl?.ctrlName === 'footer-links'" [config]="ctrl.config"></app-footer-links>
    <app-social *ngIf="ctrl?.ctrlName === 'social'" [config]="ctrl.config"></app-social>
    <app-product-header *ngIf="ctrl?.ctrlName === 'product-header'" [config]="ctrl.config"
      [data]="ctrl.config.smartLabelData"></app-product-header>

    <app-section *ngIf="ctrl?.ctrlName === 'section'" [config]="ctrl.config" [controls]="ctrl.controls"></app-section>
    <app-image *ngIf="ctrl?.ctrlName === 'image'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"> </app-image>
    <app-video *ngIf="ctrl?.ctrlName === 'video'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"> </app-video>
    <app-link *ngIf="ctrl?.ctrlName === 'link'" [config]="ctrl.config"> </app-link>


    <app-hr *ngIf="ctrl?.ctrlName === 'horizontal-rule'" [config]="ctrl.config"></app-hr>

    <app-form *ngIf="ctrl?.ctrlName === 'form'" [config]="ctrl.config" [controls]="ctrl.controls"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"></app-form>
    <app-form-input *ngIf="ctrl?.ctrlName === 'form-input'" [config]="ctrl.config"></app-form-input>
    <app-form-input *ngIf="ctrl?.ctrlName === 'form-email'" [config]="ctrl.config"></app-form-input>
    <app-form-select *ngIf="ctrl?.ctrlName === 'form-select'" [config]="ctrl.config"></app-form-select>
    <app-form-checkbox *ngIf="ctrl?.ctrlName === 'form-checkbox'" [config]="ctrl.config"></app-form-checkbox>
    <app-form-radiobox *ngIf="ctrl?.ctrlName === 'form-radiobox'" [config]="ctrl.config"></app-form-radiobox>
    <app-conditional *ngIf="ctrl?.ctrlName === 'conditional'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"
      [controls]="ctrl.controls"></app-conditional>
    <app-form-datepicker *ngIf="ctrl?.ctrlName === 'form-datepicker'" [config]="ctrl.config"></app-form-datepicker>

    <app-smartlabel-selector *ngIf="ctrl?.ctrlName === 'smartlabel-selector'" [config]="ctrl.config"
      (optionChange)="onOptionChange($event)"></app-smartlabel-selector>
    <app-badge-segment *ngIf="ctrl?.ctrlName === 'badge-segment'" [config]="ctrl.config"></app-badge-segment>


    <app-form-rating *ngIf="ctrl?.ctrlName === 'form-rating'" [config]="ctrl.config"></app-form-rating>
    <app-button *ngIf="ctrl?.ctrlName === 'button'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"
      [diLayout]="pageService.diLayout"></app-button>

    <app-auth *ngIf="ctrl?.ctrlName === 'auth'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"
      [controls]="ctrl.controls"></app-auth>


    <app-nft-verify *ngIf="ctrl?.ctrlName === 'nft-verify'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"
      [controls]="ctrl.controls"></app-nft-verify>

    <app-ve-verify *ngIf="ctrl?.ctrlName === 've-verify'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"
      [controls]="ctrl.controls"></app-ve-verify>
     

    <app-redirect *ngIf="ctrl?.ctrlName === 'redirect'" [config]="ctrl.config"
      [data]="{'entityInformation': pageService.diData, 'customGetAPI': pageService.customGetAPIData}"></app-redirect>


  </ng-container>

</ng-template>